<template>
    <div class="innerBox mt-3" style="background-color: #197D2F; padding-top:18px">
        <div class="row" style="display: flex; justify-content: space-between;">
            <h5 class="text-white" style="margin:auto 0">Pembelian Sparepart</h5>
        </div>
        <div class="divider"></div>

        <div class="align-spacely" style="height:230px"><!-- HEIGHT HERE -->

            <div class="mini-stats row">
                <div class="col-8">
                    <h3 class="custom-text-pink">PO Sparepart</h3>
                    <h3 class="text-white pl-3">{{ poSparepartTotal }}</h3>
                </div>
                <div class="col-4 icon">
                    <i class="fas fa-tools"></i>
                </div>
            </div>

            <div class="divider"></div>

            <div>
                <h3 class="custom-text-pink">PO Sparepart Detail</h3>
                <table class="w-100">
                    <tr>
                        <td class="home-table-content font-weight-bold">Belum Datang</td>
                        <td class="home-table-content text-center">{{ numberWithCommas(data.pending_spareparts) }}</td>
                    </tr>
                    <tr>
                        <td class="home-table-content font-weight-bold">Konfirmasi Datang</td>
                        <td class="home-table-content text-center">{{ numberWithCommas(data.arrived_spareparts) }}</td>
                    </tr>
                    <tr>
                        <td class="home-table-content font-weight-bold">Terpakai</td>
                        <td class="home-table-content text-center">{{ numberWithCommas(data.used_spareparts) }}</td>
                    </tr>
                    <tr>
                        <td class="home-table-content font-weight-bold">Retur</td>
                        <td class="home-table-content text-center">{{ numberWithCommas(data.returned_spareparts) }}</td>
                    </tr>
                </table>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data () {
            return {

            }
        },
        props : ['data'],
        computed : {
            poSparepartTotal() {
                if (this.data) {
                    return this.numberWithCommas(
                        parseInt(this.data.pending_spareparts) +
                        parseInt(this.data.arrived_spareparts) +
                        parseInt(this.data.used_spareparts) +
                        parseInt(this.data.returned_spareparts)
                    )
                } else {
                    return 'Loading ...'
                }
            },
        },
        mounted () {

        },
        methods : {
            
        }
    }
</script>

<style scoped>
    .innerBox {
        overflow-y: auto;
    }
</style>